// extracted by mini-css-extract-plugin
export default {"btn_container":"TaskPitchRecordBtn_btn_container__P8pI2","btn":"TaskPitchRecordBtn_btn__NuQO-"};